"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsomorphicLayoutEffect = void 0;
var react_1 = require("react");
var const_1 = require("../util/const");
/**
 * Alias for `useLayoutEffect` in browser, but for `useEffect` at server side. Helps to avoid
 * warning shown during SSR.
 */
exports.useIsomorphicLayoutEffect = const_1.isBrowser ? react_1.useLayoutEffect : react_1.useEffect;
